import { RunningSeries, RunningSeriesWithWorkouts } from '../dao/core-dao'
import { coreService } from '../service/core-service'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { queryKeys } from 'src/util/query-keys'

export const useTrainingSeriesById = (trainingSeriesId: string): UseQueryResult<RunningSeriesWithWorkouts, Error> => {
  return useQuery<RunningSeriesWithWorkouts, Error>(
    queryKeys.trainingSeriesById(trainingSeriesId),
    () => coreService.getTrainingSeriesById(trainingSeriesId),
    {
      enabled: !!trainingSeriesId,
    },
  )
}

export const useRunningSeries = (): UseQueryResult<RunningSeries[], Error> => {
  return useQuery<RunningSeries[], Error>(queryKeys.runningSeries(), () => coreService.listRunningSeries())
}
